import React, { forwardRef } from 'react';
import { connect } from 'react-redux';
import {
  selectAllAssignment,
  setBulkDate,
  removeBulkAssignment,
} from 'actions/assignmentActivity/assignment_action';
import classNames from 'classnames';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import AssignmentsTableRow from './AssignmentsTableRow';

const AssignmentTable = ({
  assignment,
  metadata,
  hideSelect,
  hideAction,
  setReminder,
  isManuallyTextAssignmentReminders,
  assignmentId,
  setSelectedId,
  selectedIds,
  setRemindAllUsers,
  selectAll,
  checkedCount,
  bulkRemove,
  setBulkDueDate,
  setIncompleteActionModal,
  markBulkComplete,
  bulkPermissions,
  sendReminderAllLearner,
}) => {
  const CustomInputHeader = forwardRef(({ onClick }, ref) => (
    <button
      onClick={onClick}
      ref={ref}
      name="button"
      type="submit"
      className="ButtonLink SelecTable-actionButton"
    >
      {t('assignments.set_due_date')}
    </button>
  ));

  const bulkDestroy = () => {
    /* eslint-disable-next-line no-alert */
    if (window.confirm(t('assignments.confirm_bulk_destroy'))) {
      bulkRemove(assignmentId);
    }
  };

  const sendReminder = reminderType => {
    if (reminderType === 'bulkReminder') {
      request
        .postJSON(routes.ASSIGNMENTS.BULK_REMINDER, {
          selected_ids: selectedIds,
          lesson_id: metadata.title === 'lesson' ? assignmentId : '',
          path_id: '',
          due_by: '',
          button: '',
        })
        .then(resp => {
          setRemindAllUsers(resp);
          setReminder(true);
        });
    }
    if (reminderType === 'bulkReminderAllLearner') {
      /* eslint-disable-next-line no-alert */
      if (window.confirm(t('assignments.confirm_remind_all'))) {
        request
          .postJSON(routes.ASSIGNMENTS.BULK_REMINDER, {
            all_assignments: 1,
            selected_ids: selectedIds,
            lesson_id: assignmentId,
            path_id: '',
            due_by: '',
            button: '',
          })
          .then(resp => {
            setRemindAllUsers(resp);
            setReminder(true);
          });
      }
    }
    if (reminderType === 'bulkRemind') {
      request.post(
        routes.ASSIGNMENTS.BULK_REMIND,
        {
          selected_ids: selectedIds,
          lesson_id: assignmentId,
          path_id: '',
          due_by: '',
          button: '',
        },
        { dataType: 'script' },
      );
    }
    if (reminderType === 'bulkRemindAllLearner') {
      /* eslint-disable-next-line no-alert */
      if (window.confirm(t('assignments.confirm_remind_all'))) {
        request.post(
          routes.ASSIGNMENTS.BULK_REMIND,
          {
            all_assignments: 1,
            selected_ids: selectedIds,
            lesson_id: assignmentId,
            path_id: '',
            due_by: '',
            button: '',
          },
          { dataType: 'script' },
        );
      }
    }
  };

  const tableHeader = classNames(
    'tablesaw tablesaw-stack DataTable AssignmentsTable AssignmentsTable--hideProgress AssignmentsTable--hideCompletedAt AssignmentsTable--hideScore AssignmentsTable--hideAttempts ',
    {
      'AssignmentsTable--hideAssignable':
        metadata.title === 'lesson' || metadata.title === 'learning_paths/path',
      'AssignmentsTable--hideAssignee': metadata.title === 'user',
      'SelecTable--hideSelect': hideSelect,
      'DataTable--hideActions': hideAction,
      'SelecTable--headerOpen': !hideSelect && checkedCount,
      'SelecTable ': !hideAction,
    },
  );

  const reminderAllLearner = classNames('SelecTable-action all-assignments ', {
    hide: !(sendReminderAllLearner && checkedCount === assignment.length),
  });

  return (
    <section className="assignments incomplete">
      <div className="tablesaw-bar mode-stack" />
      <table
        className={tableHeader}
        data-tablesaw-mode="stack"
        id={metadata.titleName}
      >
        <caption className="SelecTable-header">
          <span> {t('assignments.selected', { count: checkedCount })}:</span>
          <ul className="SelecTable-actions">
            <li className="SelecTable-action">
              <DatePicker
                onChange={date => setBulkDueDate(date)}
                popperPlacement="bottom"
                minDate={moment(Date.now())}
                customInput={<CustomInputHeader />}
              >
                <button
                  name="button"
                  type="submit"
                  className="ButtonLink SelecTable-actionButton SelecTable-dueDateSelect"
                  onClick={() => setBulkDueDate(null)}
                >
                  {t('assignments.no_due_date')}
                </button>
              </DatePicker>
            </li>
            {isManuallyTextAssignmentReminders ? (
              <>
                {bulkPermissions.canBulkRemind && (
                  <>
                    <li className="SelecTable-action">
                      <button
                        onClick={() => sendReminder('bulkReminder')}
                        name="button"
                        type="submit"
                        className="ButtonLink SelecTable-actionButton"
                      >
                        {t('assignments.remind')}
                      </button>
                    </li>
                    <li className={reminderAllLearner}>
                      <button
                        onClick={() => sendReminder('bulkReminderAllLearner')}
                        name="button"
                        type="submit"
                        className="ButtonLink SelecTable-actionButton"
                      >
                        {t('assignments.remind_all')}
                      </button>
                    </li>
                  </>
                )}
              </>
            ) : (
              <>
                {bulkPermissions.canBulkRemind && (
                  <>
                    <li className="SelecTable-action">
                      <button
                        onClick={() => sendReminder('bulkRemind')}
                        name="button"
                        type="submit"
                        className="ButtonLink SelecTable-actionButton"
                      >
                        {t('assignments.remind')}
                      </button>
                    </li>
                    <li className={reminderAllLearner}>
                      <button
                        onClick={() => sendReminder('bulkRemindAllLearner')}
                        name="button"
                        type="submit"
                        className="ButtonLink SelecTable-actionButton"
                      >
                        {t('assignments.remind_all')}
                      </button>
                    </li>
                  </>
                )}
              </>
            )}
            {metadata.title !== 'learning_paths/path' && markBulkComplete && (
              <li className="SelecTable-action">
                <button
                  onClick={() => setIncompleteActionModal(true)}
                  name="button"
                  type="submit"
                  className="ButtonLink SelecTable-actionButton"
                >
                  {t('assignments.mark_complete.title')}
                </button>
              </li>
            )}
            <li className="SelecTable-action">
              <button
                onClick={() => bulkDestroy()}
                name="button"
                type="submit"
                className="ButtonLink SelecTable-actionButton"
              >
                {t('assignments.destroy')}
              </button>
            </li>
          </ul>
        </caption>
        <thead>
          <tr>
            <th className="SelecTable-select">
              <input
                type="checkbox"
                id={hideSelect ? '' : 'select-all'}
                className="SelecTable-toggleAll"
                checked={checkedCount > 0}
                name="select_all"
                onChange={e => selectAll(e.target.checked)}
                aria-label={t('actions.bulk')}
              />
            </th>
            <th className="AssignmentsTable-status" />
            <th className="DataTable-name AssignmentsTable-assignee ">
              {t('assignments.assignee')}
            </th>
            <th className="DataTable-name AssignmentsTable-assignable">
              {t('assignments.singular')}
            </th>
            <th className="AssignmentsTable-dueDate">{t('assignments.due')}</th>
            <th className="AssignmentsTable-startedAt">
              {t('progress.started')}
            </th>
            <th className="AssignmentsTable-progress">
              {t('assignments.title')}
            </th>
            <th className="AssignmentsTable-completedAt">
              {t('assignments.completed.label')}
            </th>
            <th className="AssignmentsTable-attempts">
              {t('assignments.attempts')}
            </th>
            <th className="AssignmentsTable-score">
              {t('gradebook.export.score')}
            </th>
            <th className="DataTable-actionsRow" />
          </tr>
        </thead>
        <tbody>
          {assignment.map(data => (
            <AssignmentsTableRow
              key={data.id}
              rowData={data}
              setReminder={setReminder}
              setRemindAllUsers={setRemindAllUsers}
              setSelectedId={setSelectedId}
              setIncompleteActionModal={setIncompleteActionModal}
              isManuallyTextAssignmentReminders={
                isManuallyTextAssignmentReminders
              }
            />
          ))}
        </tbody>
      </table>
    </section>
  );
};

const mapStateToProps = state => ({
  selectedIds: state.assignDirectly.selectedIds,
  checkedCount: state.assignDirectly.checkedCount,
  markBulkComplete: state.assignDirectly.markBulkComplete,
  bulkPermissions: state.bulkPermissions.bulkPermissions,
  sendReminderAllLearner: state.bulkPermissions.isCurrentAssignableExist,
});

const mapDispatchToProps = dispatch => ({
  selectAll(checked) {
    dispatch(selectAllAssignment(checked));
  },
  bulkRemove(assignmentId) {
    dispatch(removeBulkAssignment(assignmentId));
  },
  setBulkDueDate(date) {
    dispatch(setBulkDate(date));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AssignmentTable);
